import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { LayoutService, ILayoutConfig, ItmUserService } from '@itm/services';
import { AuthService } from 'app/core/auth/auth.service';
import { firstValueFrom } from 'rxjs';

export const LayoutResolver: ResolveFn<ILayoutConfig> = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
    const embeddedAppType = {
        All: 0,
        Connect: 1,
        OnSiteLive: 2,
    }
    const parms = route.queryParams;
    if([embeddedAppType.Connect.toString(), embeddedAppType.OnSiteLive.toString()].includes(parms.parent) 
        && parms.layout == 'empty'){
        const authService = inject(AuthService);
        if(parms.accessToken){
            authService.accessToken = parms.accessToken;
        }
    }

    const _layoutService = inject(LayoutService);
    const _itmUserService = inject(ItmUserService);

    try {
        const user = await firstValueFrom(_itmUserService.upsertUser());

        const pageKey: string = route.data['pageKey'];
        _layoutService.setCurrentActivatedRoute(pageKey);
        _layoutService.setToolbarButtonClick(null);
        _layoutService.setToolbarFormButtonClick(null);

        return await firstValueFrom(_layoutService.layoutConfig$);
    } catch (error) {
        console.error('Failed to resolve layout:', error);
        return null as any;
    }
};